/* tslint:disable */
/* eslint-disable */
/* @relayHash 71b170015bc14eeed470c43589987301 */

import { ConcreteRequest } from "relay-runtime";
import { FragmentRefs } from "relay-runtime";
export type COMMENT_SORT = "CREATED_AT_ASC" | "CREATED_AT_DESC" | "REACTION_DESC" | "REPLIES_DESC" | "%future added value";
export type AnsweredCommentsQueryVariables = {
    storyID?: string | null;
    storyURL?: string | null;
    commentsOrderBy?: COMMENT_SORT | null;
};
export type AnsweredCommentsQueryResponse = {
    readonly viewer: {
        readonly " $fragmentRefs": FragmentRefs<"AnsweredCommentsContainer_viewer">;
    } | null;
    readonly story: {
        readonly " $fragmentRefs": FragmentRefs<"AnsweredCommentsContainer_story">;
    } | null;
    readonly settings: {
        readonly " $fragmentRefs": FragmentRefs<"AnsweredCommentsContainer_settings">;
    };
};
export type AnsweredCommentsQuery = {
    readonly response: AnsweredCommentsQueryResponse;
    readonly variables: AnsweredCommentsQueryVariables;
};



/*
query AnsweredCommentsQuery(
  $storyID: ID
  $storyURL: String
  $commentsOrderBy: COMMENT_SORT
) {
  viewer {
    ...AnsweredCommentsContainer_viewer
    id
  }
  story: stream(id: $storyID, url: $storyURL) {
    ...AnsweredCommentsContainer_story_H4pgm
    id
  }
  settings {
    ...AnsweredCommentsContainer_settings
    id
  }
}

fragment AnsweredCommentContainer_comment on Comment {
  id
  author {
    id
    username
  }
  parent {
    author {
      username
      id
    }
    ...CommentContainer_comment
    id
  }
  body
  createdAt
  replyCount
  ...MediaSectionContainer_comment
  ...UsernameWithPopoverContainer_comment
  ...ReactionButtonContainer_comment
  ...UserTagsContainer_comment
  ...IgnoredTombstoneOrHideContainer_comment
}

fragment AnsweredCommentContainer_settings on Settings {
  ...ReactionButtonContainer_settings
  ...UserTagsContainer_settings
  ...CommentContainer_settings
  ...MediaSectionContainer_settings
  ...UsernameWithPopoverContainer_settings
}

fragment AnsweredCommentContainer_story on Story {
  url
  ...UserTagsContainer_story
  ...CommentContainer_story
}

fragment AnsweredCommentContainer_viewer on User {
  id
  status {
    current
  }
  ignoredUsers {
    id
  }
  role
  mediaSettings {
    unfurlEmbeds
  }
  ...UsernameWithPopoverContainer_viewer
  ...ReactionButtonContainer_viewer
  ...CommentContainer_viewer
  ...IgnoredTombstoneOrHideContainer_viewer
}

fragment AnsweredCommentsContainer_settings on Settings {
  reaction {
    sortLabel
  }
  ...AnsweredCommentContainer_settings
}

fragment AnsweredCommentsContainer_story_H4pgm on Story {
  id
  featuredComments(first: 5, orderBy: $commentsOrderBy) {
    edges {
      node {
        id
        ...AnsweredCommentContainer_comment
        __typename
      }
      cursor
    }
    pageInfo {
      endCursor
      hasNextPage
    }
  }
  ...PostCommentFormContainer_story
  ...AnsweredCommentContainer_story
}

fragment AnsweredCommentsContainer_viewer on User {
  ...AnsweredCommentContainer_viewer
  status {
    current
  }
}

fragment CaretContainer_comment on Comment {
  id
  ...ModerationDropdownContainer_comment
}

fragment CaretContainer_settings on Settings {
  ...ModerationDropdownContainer_settings
}

fragment CaretContainer_story on Story {
  ...ModerationDropdownContainer_story
}

fragment CaretContainer_viewer on User {
  ...ModerationDropdownContainer_viewer
}

fragment CommentContainer_comment on Comment {
  id
  author {
    id
    username
    avatar
    badges
  }
  parent {
    author {
      username
      id
    }
    id
  }
  body
  createdAt
  status
  rating
  editing {
    edited
    editableUntil
  }
  tags {
    code
  }
  deleted
  actionCounts {
    reaction {
      total
    }
  }
  viewerActionPresence {
    dontAgree
    flag
  }
  ...CaretContainer_comment
  ...EditCommentFormContainer_comment
  ...MediaSectionContainer_comment
  ...ReactionButtonContainer_comment
  ...ModerationRejectedTombstoneContainer_comment
  ...ReplyCommentFormContainer_comment
  ...ReportButton_comment
  ...ReportFlowContainer_comment
  ...UsernameContainer_comment
  ...UsernameWithPopoverContainer_comment
  ...UserTagsContainer_comment
}

fragment CommentContainer_settings on Settings {
  disableCommenting {
    enabled
  }
  featureFlags
  ...CaretContainer_settings
  ...EditCommentFormContainer_settings
  ...MediaSectionContainer_settings
  ...ReactionButtonContainer_settings
  ...ReplyCommentFormContainer_settings
  ...ReportFlowContainer_settings
  ...UsernameWithPopoverContainer_settings
  ...UserTagsContainer_settings
}

fragment CommentContainer_story on Story {
  id
  url
  isClosed
  canModerate
  settings {
    mode
  }
  ...CaretContainer_story
  ...EditCommentFormContainer_story
  ...PermalinkButtonContainer_story
  ...ReplyCommentFormContainer_story
  ...UserTagsContainer_story
}

fragment CommentContainer_viewer on User {
  id
  status {
    current
  }
  ignoredUsers {
    id
  }
  badges
  role
  scheduledDeletionDate
  mediaSettings {
    unfurlEmbeds
  }
  ...UsernameWithPopoverContainer_viewer
  ...ReactionButtonContainer_viewer
  ...ReportFlowContainer_viewer
  ...ReportButton_viewer
  ...CaretContainer_viewer
}

fragment EditCommentFormContainer_comment on Comment {
  id
  body
  createdAt
  revision {
    id
    media {
      __typename
      ... on GiphyMedia {
        url
        title
        width
        height
        still
        video
      }
      ... on TwitterMedia {
        url
        width
      }
      ... on YouTubeMedia {
        url
        width
        height
      }
      ... on ExternalMedia {
        url
      }
    }
  }
  author {
    username
    id
  }
  editing {
    editableUntil
  }
  site {
    id
  }
}

fragment EditCommentFormContainer_settings on Settings {
  charCount {
    enabled
    min
    max
  }
  media {
    twitter {
      enabled
    }
    youtube {
      enabled
    }
    giphy {
      enabled
      key
      maxRating
    }
    external {
      enabled
    }
  }
  rte {
    ...RTEContainer_config
  }
}

fragment EditCommentFormContainer_story on Story {
  id
}

fragment IgnoredTombstoneOrHideContainer_comment on Comment {
  author {
    id
    username
  }
}

fragment IgnoredTombstoneOrHideContainer_viewer on User {
  ignoredUsers {
    id
  }
}

fragment MediaSectionContainer_comment on Comment {
  id
  site {
    id
  }
  revision {
    media {
      __typename
      ... on GiphyMedia {
        url
        title
        width
        height
        still
        video
      }
      ... on TwitterMedia {
        url
        width
      }
      ... on YouTubeMedia {
        url
        width
        height
      }
      ... on ExternalMedia {
        url
      }
    }
    id
  }
}

fragment MediaSectionContainer_settings on Settings {
  media {
    twitter {
      enabled
    }
    youtube {
      enabled
    }
    giphy {
      enabled
    }
    external {
      enabled
    }
  }
}

fragment MessageBoxContainer_story on Story {
  settings {
    messageBox {
      content
      icon
    }
    mode
  }
}

fragment ModerationActionsContainer_comment on Comment {
  id
  author {
    id
  }
  revision {
    id
  }
  status
  tags {
    code
  }
}

fragment ModerationActionsContainer_settings on Settings {
  auth {
    integrations {
      sso {
        enabled
        targetFilter {
          admin
        }
      }
    }
  }
}

fragment ModerationActionsContainer_story on Story {
  id
  settings {
    mode
  }
}

fragment ModerationActionsContainer_viewer on User {
  id
  moderationScopes {
    scoped
  }
}

fragment ModerationDropdownContainer_comment on Comment {
  id
  author {
    id
    username
  }
  revision {
    id
  }
  status
  tags {
    code
  }
  ...ModerationActionsContainer_comment
  ...UserBanPopoverContainer_comment
}

fragment ModerationDropdownContainer_settings on Settings {
  ...ModerationActionsContainer_settings
  ...UserBanPopoverContainer_settings
}

fragment ModerationDropdownContainer_story on Story {
  id
  ...ModerationActionsContainer_story
  ...UserBanPopoverContainer_story
}

fragment ModerationDropdownContainer_viewer on User {
  ...ModerationActionsContainer_viewer
}

fragment ModerationRejectedTombstoneContainer_comment on Comment {
  id
}

fragment PermalinkButtonContainer_story on Story {
  url
}

fragment PostCommentFormContainer_story on Story {
  id
  isClosed
  site {
    id
  }
  viewerRating {
    id
    status
    tags {
      code
    }
    rating
  }
  settings {
    messageBox {
      enabled
    }
    experts {
      id
    }
    mode
  }
  ...MessageBoxContainer_story
}

fragment RTEContainer_config on RTEConfiguration {
  enabled
  strikethrough
  spoiler
  sarcasm
}

fragment ReactionButtonContainer_comment on Comment {
  id
  author {
    id
    username
  }
  revision {
    id
  }
  viewerActionPresence {
    reaction
  }
  actionCounts {
    reaction {
      total
    }
  }
}

fragment ReactionButtonContainer_settings on Settings {
  reaction {
    label
    labelActive
    icon
    iconActive
  }
}

fragment ReactionButtonContainer_viewer on User {
  id
}

fragment ReplyCommentFormContainer_comment on Comment {
  id
  site {
    id
  }
  author {
    username
    id
  }
  revision {
    id
  }
}

fragment ReplyCommentFormContainer_settings on Settings {
  charCount {
    enabled
    min
    max
  }
  disableCommenting {
    enabled
    message
  }
  closeCommenting {
    message
  }
  media {
    twitter {
      enabled
    }
    youtube {
      enabled
    }
    giphy {
      enabled
      key
      maxRating
    }
    external {
      enabled
    }
  }
  rte {
    ...RTEContainer_config
  }
}

fragment ReplyCommentFormContainer_story on Story {
  id
  isClosed
}

fragment ReportButton_comment on Comment {
  id
  author {
    username
    id
  }
  viewerActionPresence {
    dontAgree
    flag
  }
}

fragment ReportButton_viewer on User {
  id
}

fragment ReportCommentFormContainer_comment on Comment {
  id
  revision {
    id
  }
}

fragment ReportCommentFormContainer_settings on Settings {
  memberBios
}

fragment ReportFlowContainer_comment on Comment {
  ...ReportCommentFormContainer_comment
  id
  viewerActionPresence {
    dontAgree
    flag
  }
}

fragment ReportFlowContainer_settings on Settings {
  ...ReportCommentFormContainer_settings
}

fragment ReportFlowContainer_viewer on User {
  id
}

fragment StaffTagContainer_settings on Settings {
  staff {
    staffLabel
    adminLabel
    moderatorLabel
  }
}

fragment UserBanPopoverContainer_comment on Comment {
  id
  revision {
    id
  }
  status
  author {
    id
    username
  }
}

fragment UserBanPopoverContainer_settings on Settings {
  featureFlags
}

fragment UserBanPopoverContainer_story on Story {
  id
  site {
    id
    name
  }
}

fragment UserIgnorePopoverContainer_user on User {
  id
  username
}

fragment UserPopoverContainer_settings on Settings {
  ...UserPopoverOverviewContainer_settings
}

fragment UserPopoverContainer_user on User {
  id
  ...UserPopoverOverviewContainer_user
  ...UserIgnorePopoverContainer_user
}

fragment UserPopoverContainer_viewer on User {
  ...UserPopoverOverviewContainer_viewer
}

fragment UserPopoverOverviewContainer_settings on Settings {
  memberBios
}

fragment UserPopoverOverviewContainer_user on User {
  id
  username
  createdAt
  ignoreable
  bio
}

fragment UserPopoverOverviewContainer_viewer on User {
  id
  ignoredUsers {
    id
  }
}

fragment UserTagsContainer_comment on Comment {
  tags {
    code
  }
}

fragment UserTagsContainer_settings on Settings {
  ...StaffTagContainer_settings
}

fragment UserTagsContainer_story on Story {
  settings {
    mode
  }
}

fragment UsernameContainer_comment on Comment {
  id
  author {
    username
    id
  }
}

fragment UsernameWithPopoverContainer_comment on Comment {
  id
  author {
    id
    username
    ...UserPopoverContainer_user
  }
}

fragment UsernameWithPopoverContainer_settings on Settings {
  ...UserPopoverContainer_settings
}

fragment UsernameWithPopoverContainer_viewer on User {
  ...UserPopoverContainer_viewer
}
*/

const node: ConcreteRequest = (function () {
    var v0 = ({
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "commentsOrderBy"
    } as any), v1 = ({
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "storyID"
    } as any), v2 = ({
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "storyURL"
    } as any), v3 = [
        ({
            "kind": "Variable",
            "name": "id",
            "variableName": "storyID"
        } as any),
        ({
            "kind": "Variable",
            "name": "url",
            "variableName": "storyURL"
        } as any)
    ], v4 = ({
        "kind": "Variable",
        "name": "orderBy",
        "variableName": "commentsOrderBy"
    } as any), v5 = ({
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "id",
        "storageKey": null
    } as any), v6 = [
        (v5 /*: any*/)
    ], v7 = ({
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "badges",
        "storageKey": null
    } as any), v8 = [
        ({
            "kind": "Literal",
            "name": "first",
            "value": 5
        } as any),
        (v4 /*: any*/)
    ], v9 = ({
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "username",
        "storageKey": null
    } as any), v10 = ({
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "createdAt",
        "storageKey": null
    } as any), v11 = ({
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "ignoreable",
        "storageKey": null
    } as any), v12 = ({
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "bio",
        "storageKey": null
    } as any), v13 = ({
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "body",
        "storageKey": null
    } as any), v14 = ({
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "status",
        "storageKey": null
    } as any), v15 = ({
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "rating",
        "storageKey": null
    } as any), v16 = ({
        "alias": null,
        "args": null,
        "concreteType": "Tag",
        "kind": "LinkedField",
        "name": "tags",
        "plural": true,
        "selections": [
            {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "code",
                "storageKey": null
            }
        ],
        "storageKey": null
    } as any), v17 = ({
        "alias": null,
        "args": null,
        "concreteType": "ActionCounts",
        "kind": "LinkedField",
        "name": "actionCounts",
        "plural": false,
        "selections": [
            {
                "alias": null,
                "args": null,
                "concreteType": "ReactionActionCounts",
                "kind": "LinkedField",
                "name": "reaction",
                "plural": false,
                "selections": [
                    {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "total",
                        "storageKey": null
                    }
                ],
                "storageKey": null
            }
        ],
        "storageKey": null
    } as any), v18 = ({
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "reaction",
        "storageKey": null
    } as any), v19 = ({
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "__typename",
        "storageKey": null
    } as any), v20 = ({
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "url",
        "storageKey": null
    } as any), v21 = ({
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "width",
        "storageKey": null
    } as any), v22 = ({
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "height",
        "storageKey": null
    } as any), v23 = ({
        "alias": null,
        "args": null,
        "concreteType": null,
        "kind": "LinkedField",
        "name": "media",
        "plural": false,
        "selections": [
            (v19 /*: any*/),
            {
                "kind": "InlineFragment",
                "selections": [
                    (v20 /*: any*/),
                    {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "title",
                        "storageKey": null
                    },
                    (v21 /*: any*/),
                    (v22 /*: any*/),
                    {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "still",
                        "storageKey": null
                    },
                    {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "video",
                        "storageKey": null
                    }
                ],
                "type": "GiphyMedia",
                "abstractKey": null
            },
            {
                "kind": "InlineFragment",
                "selections": [
                    (v20 /*: any*/),
                    (v21 /*: any*/)
                ],
                "type": "TwitterMedia",
                "abstractKey": null
            },
            {
                "kind": "InlineFragment",
                "selections": [
                    (v20 /*: any*/),
                    (v21 /*: any*/),
                    (v22 /*: any*/)
                ],
                "type": "YouTubeMedia",
                "abstractKey": null
            },
            {
                "kind": "InlineFragment",
                "selections": [
                    (v20 /*: any*/)
                ],
                "type": "ExternalMedia",
                "abstractKey": null
            }
        ],
        "storageKey": null
    } as any), v24 = ({
        "alias": null,
        "args": null,
        "concreteType": "Site",
        "kind": "LinkedField",
        "name": "site",
        "plural": false,
        "selections": (v6 /*: any*/),
        "storageKey": null
    } as any), v25 = ({
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "lastViewerAction",
        "storageKey": null
    } as any), v26 = ({
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "enabled",
        "storageKey": null
    } as any), v27 = ({
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "icon",
        "storageKey": null
    } as any), v28 = ({
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "message",
        "storageKey": null
    } as any), v29 = [
        (v26 /*: any*/)
    ];
    return {
        "fragment": {
            "argumentDefinitions": [
                (v0 /*: any*/),
                (v1 /*: any*/),
                (v2 /*: any*/)
            ],
            "kind": "Fragment",
            "metadata": null,
            "name": "AnsweredCommentsQuery",
            "selections": [
                {
                    "alias": null,
                    "args": null,
                    "concreteType": "User",
                    "kind": "LinkedField",
                    "name": "viewer",
                    "plural": false,
                    "selections": [
                        {
                            "args": null,
                            "kind": "FragmentSpread",
                            "name": "AnsweredCommentsContainer_viewer"
                        }
                    ],
                    "storageKey": null
                },
                {
                    "alias": "story",
                    "args": (v3 /*: any*/),
                    "concreteType": "Story",
                    "kind": "LinkedField",
                    "name": "stream",
                    "plural": false,
                    "selections": [
                        {
                            "args": [
                                (v4 /*: any*/)
                            ],
                            "kind": "FragmentSpread",
                            "name": "AnsweredCommentsContainer_story"
                        }
                    ],
                    "storageKey": null
                },
                {
                    "alias": null,
                    "args": null,
                    "concreteType": "Settings",
                    "kind": "LinkedField",
                    "name": "settings",
                    "plural": false,
                    "selections": [
                        {
                            "args": null,
                            "kind": "FragmentSpread",
                            "name": "AnsweredCommentsContainer_settings"
                        }
                    ],
                    "storageKey": null
                }
            ],
            "type": "Query",
            "abstractKey": null
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [
                (v1 /*: any*/),
                (v2 /*: any*/),
                (v0 /*: any*/)
            ],
            "kind": "Operation",
            "name": "AnsweredCommentsQuery",
            "selections": [
                {
                    "alias": null,
                    "args": null,
                    "concreteType": "User",
                    "kind": "LinkedField",
                    "name": "viewer",
                    "plural": false,
                    "selections": [
                        (v5 /*: any*/),
                        {
                            "alias": null,
                            "args": null,
                            "concreteType": "UserStatus",
                            "kind": "LinkedField",
                            "name": "status",
                            "plural": false,
                            "selections": [
                                {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "current",
                                    "storageKey": null
                                }
                            ],
                            "storageKey": null
                        },
                        {
                            "alias": null,
                            "args": null,
                            "concreteType": "User",
                            "kind": "LinkedField",
                            "name": "ignoredUsers",
                            "plural": true,
                            "selections": (v6 /*: any*/),
                            "storageKey": null
                        },
                        {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "role",
                            "storageKey": null
                        },
                        {
                            "alias": null,
                            "args": null,
                            "concreteType": "UserMediaSettings",
                            "kind": "LinkedField",
                            "name": "mediaSettings",
                            "plural": false,
                            "selections": [
                                {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "unfurlEmbeds",
                                    "storageKey": null
                                }
                            ],
                            "storageKey": null
                        },
                        (v7 /*: any*/),
                        {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "scheduledDeletionDate",
                            "storageKey": null
                        },
                        {
                            "alias": null,
                            "args": null,
                            "concreteType": "UserModerationScopes",
                            "kind": "LinkedField",
                            "name": "moderationScopes",
                            "plural": false,
                            "selections": [
                                {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "scoped",
                                    "storageKey": null
                                }
                            ],
                            "storageKey": null
                        }
                    ],
                    "storageKey": null
                },
                {
                    "alias": "story",
                    "args": (v3 /*: any*/),
                    "concreteType": "Story",
                    "kind": "LinkedField",
                    "name": "stream",
                    "plural": false,
                    "selections": [
                        (v5 /*: any*/),
                        {
                            "alias": null,
                            "args": (v8 /*: any*/),
                            "concreteType": "CommentsConnection",
                            "kind": "LinkedField",
                            "name": "featuredComments",
                            "plural": false,
                            "selections": [
                                {
                                    "alias": null,
                                    "args": null,
                                    "concreteType": "CommentEdge",
                                    "kind": "LinkedField",
                                    "name": "edges",
                                    "plural": true,
                                    "selections": [
                                        {
                                            "alias": null,
                                            "args": null,
                                            "concreteType": "Comment",
                                            "kind": "LinkedField",
                                            "name": "node",
                                            "plural": false,
                                            "selections": [
                                                (v5 /*: any*/),
                                                {
                                                    "alias": null,
                                                    "args": null,
                                                    "concreteType": "User",
                                                    "kind": "LinkedField",
                                                    "name": "author",
                                                    "plural": false,
                                                    "selections": [
                                                        (v5 /*: any*/),
                                                        (v9 /*: any*/),
                                                        (v10 /*: any*/),
                                                        (v11 /*: any*/),
                                                        (v12 /*: any*/)
                                                    ],
                                                    "storageKey": null
                                                },
                                                {
                                                    "alias": null,
                                                    "args": null,
                                                    "concreteType": "Comment",
                                                    "kind": "LinkedField",
                                                    "name": "parent",
                                                    "plural": false,
                                                    "selections": [
                                                        {
                                                            "alias": null,
                                                            "args": null,
                                                            "concreteType": "User",
                                                            "kind": "LinkedField",
                                                            "name": "author",
                                                            "plural": false,
                                                            "selections": [
                                                                (v9 /*: any*/),
                                                                (v5 /*: any*/),
                                                                {
                                                                    "alias": null,
                                                                    "args": null,
                                                                    "kind": "ScalarField",
                                                                    "name": "avatar",
                                                                    "storageKey": null
                                                                },
                                                                (v7 /*: any*/),
                                                                (v10 /*: any*/),
                                                                (v11 /*: any*/),
                                                                (v12 /*: any*/)
                                                            ],
                                                            "storageKey": null
                                                        },
                                                        (v5 /*: any*/),
                                                        {
                                                            "alias": null,
                                                            "args": null,
                                                            "concreteType": "Comment",
                                                            "kind": "LinkedField",
                                                            "name": "parent",
                                                            "plural": false,
                                                            "selections": [
                                                                {
                                                                    "alias": null,
                                                                    "args": null,
                                                                    "concreteType": "User",
                                                                    "kind": "LinkedField",
                                                                    "name": "author",
                                                                    "plural": false,
                                                                    "selections": [
                                                                        (v9 /*: any*/),
                                                                        (v5 /*: any*/)
                                                                    ],
                                                                    "storageKey": null
                                                                },
                                                                (v5 /*: any*/)
                                                            ],
                                                            "storageKey": null
                                                        },
                                                        (v13 /*: any*/),
                                                        (v10 /*: any*/),
                                                        (v14 /*: any*/),
                                                        (v15 /*: any*/),
                                                        {
                                                            "alias": null,
                                                            "args": null,
                                                            "concreteType": "EditInfo",
                                                            "kind": "LinkedField",
                                                            "name": "editing",
                                                            "plural": false,
                                                            "selections": [
                                                                {
                                                                    "alias": null,
                                                                    "args": null,
                                                                    "kind": "ScalarField",
                                                                    "name": "edited",
                                                                    "storageKey": null
                                                                },
                                                                {
                                                                    "alias": null,
                                                                    "args": null,
                                                                    "kind": "ScalarField",
                                                                    "name": "editableUntil",
                                                                    "storageKey": null
                                                                }
                                                            ],
                                                            "storageKey": null
                                                        },
                                                        (v16 /*: any*/),
                                                        {
                                                            "alias": null,
                                                            "args": null,
                                                            "kind": "ScalarField",
                                                            "name": "deleted",
                                                            "storageKey": null
                                                        },
                                                        (v17 /*: any*/),
                                                        {
                                                            "alias": null,
                                                            "args": null,
                                                            "concreteType": "ActionPresence",
                                                            "kind": "LinkedField",
                                                            "name": "viewerActionPresence",
                                                            "plural": false,
                                                            "selections": [
                                                                {
                                                                    "alias": null,
                                                                    "args": null,
                                                                    "kind": "ScalarField",
                                                                    "name": "dontAgree",
                                                                    "storageKey": null
                                                                },
                                                                {
                                                                    "alias": null,
                                                                    "args": null,
                                                                    "kind": "ScalarField",
                                                                    "name": "flag",
                                                                    "storageKey": null
                                                                },
                                                                (v18 /*: any*/)
                                                            ],
                                                            "storageKey": null
                                                        },
                                                        {
                                                            "alias": null,
                                                            "args": null,
                                                            "concreteType": "CommentRevision",
                                                            "kind": "LinkedField",
                                                            "name": "revision",
                                                            "plural": false,
                                                            "selections": [
                                                                (v5 /*: any*/),
                                                                (v23 /*: any*/)
                                                            ],
                                                            "storageKey": null
                                                        },
                                                        (v24 /*: any*/),
                                                        {
                                                            "kind": "ClientExtension",
                                                            "selections": [
                                                                {
                                                                    "alias": null,
                                                                    "args": null,
                                                                    "kind": "ScalarField",
                                                                    "name": "pending",
                                                                    "storageKey": null
                                                                },
                                                                (v25 /*: any*/)
                                                            ]
                                                        }
                                                    ],
                                                    "storageKey": null
                                                },
                                                (v13 /*: any*/),
                                                (v10 /*: any*/),
                                                {
                                                    "alias": null,
                                                    "args": null,
                                                    "kind": "ScalarField",
                                                    "name": "replyCount",
                                                    "storageKey": null
                                                },
                                                (v24 /*: any*/),
                                                {
                                                    "alias": null,
                                                    "args": null,
                                                    "concreteType": "CommentRevision",
                                                    "kind": "LinkedField",
                                                    "name": "revision",
                                                    "plural": false,
                                                    "selections": [
                                                        (v23 /*: any*/),
                                                        (v5 /*: any*/)
                                                    ],
                                                    "storageKey": null
                                                },
                                                {
                                                    "alias": null,
                                                    "args": null,
                                                    "concreteType": "ActionPresence",
                                                    "kind": "LinkedField",
                                                    "name": "viewerActionPresence",
                                                    "plural": false,
                                                    "selections": [
                                                        (v18 /*: any*/)
                                                    ],
                                                    "storageKey": null
                                                },
                                                (v17 /*: any*/),
                                                (v16 /*: any*/),
                                                (v19 /*: any*/),
                                                {
                                                    "kind": "ClientExtension",
                                                    "selections": [
                                                        (v25 /*: any*/)
                                                    ]
                                                }
                                            ],
                                            "storageKey": null
                                        },
                                        {
                                            "alias": null,
                                            "args": null,
                                            "kind": "ScalarField",
                                            "name": "cursor",
                                            "storageKey": null
                                        }
                                    ],
                                    "storageKey": null
                                },
                                {
                                    "alias": null,
                                    "args": null,
                                    "concreteType": "PageInfo",
                                    "kind": "LinkedField",
                                    "name": "pageInfo",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "alias": null,
                                            "args": null,
                                            "kind": "ScalarField",
                                            "name": "endCursor",
                                            "storageKey": null
                                        },
                                        {
                                            "alias": null,
                                            "args": null,
                                            "kind": "ScalarField",
                                            "name": "hasNextPage",
                                            "storageKey": null
                                        }
                                    ],
                                    "storageKey": null
                                }
                            ],
                            "storageKey": null
                        },
                        {
                            "alias": null,
                            "args": (v8 /*: any*/),
                            "filters": [
                                "orderBy"
                            ],
                            "handle": "connection",
                            "key": "Stream_featuredComments",
                            "kind": "LinkedHandle",
                            "name": "featuredComments"
                        },
                        {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "isClosed",
                            "storageKey": null
                        },
                        {
                            "alias": null,
                            "args": null,
                            "concreteType": "Site",
                            "kind": "LinkedField",
                            "name": "site",
                            "plural": false,
                            "selections": [
                                (v5 /*: any*/),
                                {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "name",
                                    "storageKey": null
                                }
                            ],
                            "storageKey": null
                        },
                        {
                            "alias": null,
                            "args": null,
                            "concreteType": "Comment",
                            "kind": "LinkedField",
                            "name": "viewerRating",
                            "plural": false,
                            "selections": [
                                (v5 /*: any*/),
                                (v14 /*: any*/),
                                (v16 /*: any*/),
                                (v15 /*: any*/)
                            ],
                            "storageKey": null
                        },
                        {
                            "alias": null,
                            "args": null,
                            "concreteType": "StorySettings",
                            "kind": "LinkedField",
                            "name": "settings",
                            "plural": false,
                            "selections": [
                                {
                                    "alias": null,
                                    "args": null,
                                    "concreteType": "StoryMessageBox",
                                    "kind": "LinkedField",
                                    "name": "messageBox",
                                    "plural": false,
                                    "selections": [
                                        (v26 /*: any*/),
                                        {
                                            "alias": null,
                                            "args": null,
                                            "kind": "ScalarField",
                                            "name": "content",
                                            "storageKey": null
                                        },
                                        (v27 /*: any*/)
                                    ],
                                    "storageKey": null
                                },
                                {
                                    "alias": null,
                                    "args": null,
                                    "concreteType": "User",
                                    "kind": "LinkedField",
                                    "name": "experts",
                                    "plural": true,
                                    "selections": (v6 /*: any*/),
                                    "storageKey": null
                                },
                                {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "mode",
                                    "storageKey": null
                                }
                            ],
                            "storageKey": null
                        },
                        (v20 /*: any*/),
                        {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "canModerate",
                            "storageKey": null
                        }
                    ],
                    "storageKey": null
                },
                {
                    "alias": null,
                    "args": null,
                    "concreteType": "Settings",
                    "kind": "LinkedField",
                    "name": "settings",
                    "plural": false,
                    "selections": [
                        {
                            "alias": null,
                            "args": null,
                            "concreteType": "ReactionConfiguration",
                            "kind": "LinkedField",
                            "name": "reaction",
                            "plural": false,
                            "selections": [
                                {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "sortLabel",
                                    "storageKey": null
                                },
                                {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "label",
                                    "storageKey": null
                                },
                                {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "labelActive",
                                    "storageKey": null
                                },
                                (v27 /*: any*/),
                                {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "iconActive",
                                    "storageKey": null
                                }
                            ],
                            "storageKey": null
                        },
                        {
                            "alias": null,
                            "args": null,
                            "concreteType": "StaffConfiguration",
                            "kind": "LinkedField",
                            "name": "staff",
                            "plural": false,
                            "selections": [
                                {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "staffLabel",
                                    "storageKey": null
                                },
                                {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "adminLabel",
                                    "storageKey": null
                                },
                                {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "moderatorLabel",
                                    "storageKey": null
                                }
                            ],
                            "storageKey": null
                        },
                        {
                            "alias": null,
                            "args": null,
                            "concreteType": "DisableCommenting",
                            "kind": "LinkedField",
                            "name": "disableCommenting",
                            "plural": false,
                            "selections": [
                                (v26 /*: any*/),
                                (v28 /*: any*/)
                            ],
                            "storageKey": null
                        },
                        {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "featureFlags",
                            "storageKey": null
                        },
                        {
                            "alias": null,
                            "args": null,
                            "concreteType": "Auth",
                            "kind": "LinkedField",
                            "name": "auth",
                            "plural": false,
                            "selections": [
                                {
                                    "alias": null,
                                    "args": null,
                                    "concreteType": "AuthIntegrations",
                                    "kind": "LinkedField",
                                    "name": "integrations",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "alias": null,
                                            "args": null,
                                            "concreteType": "SSOAuthIntegration",
                                            "kind": "LinkedField",
                                            "name": "sso",
                                            "plural": false,
                                            "selections": [
                                                (v26 /*: any*/),
                                                {
                                                    "alias": null,
                                                    "args": null,
                                                    "concreteType": "AuthenticationTargetFilter",
                                                    "kind": "LinkedField",
                                                    "name": "targetFilter",
                                                    "plural": false,
                                                    "selections": [
                                                        {
                                                            "alias": null,
                                                            "args": null,
                                                            "kind": "ScalarField",
                                                            "name": "admin",
                                                            "storageKey": null
                                                        }
                                                    ],
                                                    "storageKey": null
                                                }
                                            ],
                                            "storageKey": null
                                        }
                                    ],
                                    "storageKey": null
                                }
                            ],
                            "storageKey": null
                        },
                        {
                            "alias": null,
                            "args": null,
                            "concreteType": "CharCount",
                            "kind": "LinkedField",
                            "name": "charCount",
                            "plural": false,
                            "selections": [
                                (v26 /*: any*/),
                                {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "min",
                                    "storageKey": null
                                },
                                {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "max",
                                    "storageKey": null
                                }
                            ],
                            "storageKey": null
                        },
                        {
                            "alias": null,
                            "args": null,
                            "concreteType": "MediaConfiguration",
                            "kind": "LinkedField",
                            "name": "media",
                            "plural": false,
                            "selections": [
                                {
                                    "alias": null,
                                    "args": null,
                                    "concreteType": "TwitterMediaConfiguration",
                                    "kind": "LinkedField",
                                    "name": "twitter",
                                    "plural": false,
                                    "selections": (v29 /*: any*/),
                                    "storageKey": null
                                },
                                {
                                    "alias": null,
                                    "args": null,
                                    "concreteType": "YouTubeMediaConfiguration",
                                    "kind": "LinkedField",
                                    "name": "youtube",
                                    "plural": false,
                                    "selections": (v29 /*: any*/),
                                    "storageKey": null
                                },
                                {
                                    "alias": null,
                                    "args": null,
                                    "concreteType": "GiphyMediaConfiguration",
                                    "kind": "LinkedField",
                                    "name": "giphy",
                                    "plural": false,
                                    "selections": [
                                        (v26 /*: any*/),
                                        {
                                            "alias": null,
                                            "args": null,
                                            "kind": "ScalarField",
                                            "name": "key",
                                            "storageKey": null
                                        },
                                        {
                                            "alias": null,
                                            "args": null,
                                            "kind": "ScalarField",
                                            "name": "maxRating",
                                            "storageKey": null
                                        }
                                    ],
                                    "storageKey": null
                                },
                                {
                                    "alias": null,
                                    "args": null,
                                    "concreteType": "ExternalMediaConfiguration",
                                    "kind": "LinkedField",
                                    "name": "external",
                                    "plural": false,
                                    "selections": (v29 /*: any*/),
                                    "storageKey": null
                                }
                            ],
                            "storageKey": null
                        },
                        {
                            "alias": null,
                            "args": null,
                            "concreteType": "RTEConfiguration",
                            "kind": "LinkedField",
                            "name": "rte",
                            "plural": false,
                            "selections": [
                                (v26 /*: any*/),
                                {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "strikethrough",
                                    "storageKey": null
                                },
                                {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "spoiler",
                                    "storageKey": null
                                },
                                {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "sarcasm",
                                    "storageKey": null
                                }
                            ],
                            "storageKey": null
                        },
                        {
                            "alias": null,
                            "args": null,
                            "concreteType": "CloseCommenting",
                            "kind": "LinkedField",
                            "name": "closeCommenting",
                            "plural": false,
                            "selections": [
                                (v28 /*: any*/)
                            ],
                            "storageKey": null
                        },
                        {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "memberBios",
                            "storageKey": null
                        },
                        (v5 /*: any*/)
                    ],
                    "storageKey": null
                }
            ]
        },
        "params": {
            "id": "71b170015bc14eeed470c43589987301",
            "metadata": {},
            "name": "AnsweredCommentsQuery",
            "operationKind": "query",
            "text": null
        }
    } as any;
})();
(node as any).hash = 'cbe73b44a2b05efaa15de6e8f2740320';
export default node;
